import { render, staticRenderFns } from "./memory.vue?vue&type=template&id=7c9aeca3&scoped=true&"
import script from "./memory.vue?vue&type=script&lang=js&"
export * from "./memory.vue?vue&type=script&lang=js&"
import style0 from "./memory.vue?vue&type=style&index=0&id=7c9aeca3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9aeca3",
  null
  
)

export default component.exports